import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_event/$eventSlug/quizzes/')({
  beforeLoad: () => {
    throw redirect({
      to: '/quizzes',
      replace: true
    })
  }
})
